import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const InputContainer = styled.label`
    height: 70px;
    border-radius: 12px;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    line-height: 24px;
    color: ${(props) => props.theme.purple_100};
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    cursor: pointer;
    box-sizing: border-box;
    display: flex;

    &:hover {
        background: ${(props) => props.theme.purple_8_tr};
    }

    ${media.tablet720} {
        height: 70px;
    }

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }
`;

export const Input = styled.input`
    opacity: 0;
    height: 0;
    width: 0;
`;
